import { useState, useEffect } from "react";
import { Button } from "Components/Button";
import { getMedicalClaimFile } from "Requests/Partners/PreBudgets";
import { DocumentItem } from "./DocumentItem";

interface DocumentsProps {
  files: { file_path: string }[] | undefined;
}

export const Documents = ({ files }: DocumentsProps) => {
  const [tabSelected, setTabSelected] = useState(1);
  const [fileBlob, setFileBlob] = useState<Blob | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const currentFileView = files?.[tabSelected - 1];

  useEffect(() => {
    const fetchFile = async () => {
      if (currentFileView?.file_path) {
        setIsLoading(true);
        try {
          const blob = await getMedicalClaimFile(currentFileView.file_path);
          setFileBlob(blob);
        } catch (error) {
          console.error("Erro ao buscar arquivo:", error);
          setFileBlob(null);
        } finally {
          setIsLoading(false);
        }
      }
    };

    fetchFile();
  }, [currentFileView?.file_path]);

  // Cleanup object URL quando o componente for desmontado ou o blob mudar
  useEffect(() => {
    return () => {
      if (fileBlob) {
        // O object URL será limpo automaticamente quando o blob for destruído
      }
    };
  }, [fileBlob]);

  return (
    <div className="documents-preview-style">
      <div className="tabs">
        {files?.map((file, index) => (
          <Button
            key={file.file_path}
            onClick={() => setTabSelected(index + 1)}
            outlined
            {...(index + 1 === tabSelected && { outlined: false })}
          >
            Arquivo {index + 1}
          </Button>
        ))}
      </div>

      <div className="documents-preview">
        {currentFileView && (
          <DocumentItem
            index={tabSelected}
            fileBlob={fileBlob}
            isLoading={isLoading}
          />
        )}
      </div>
    </div>
  );
};
